// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEnum$dGeneric from "../Data.Enum.Generic/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dEnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic$dCoreSites$dTranslations$dKeys from "../Restaumatic.CoreSites.Translations.Keys/index.js";
import * as Restaumatic$dForm$dMetadata from "../Restaumatic.Form.Metadata/index.js";
import * as Restaumatic$dForm$dTestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unscramble$dEnum from "../Unscramble.Enum/index.js";
const $FulfillmentMethodType = tag => ({tag});
const DeliveryIsSymbol = {reflectSymbol: () => "Delivery"};
const TakeawayIsSymbol = {reflectSymbol: () => "Takeaway"};
const DineInIsSymbol = {reflectSymbol: () => "DineIn"};
const NoContactDeliveryIsSymbol = {reflectSymbol: () => "NoContactDelivery"};
const genericTopConstructor = {"genericTop'": Data$dGeneric$dRep.NoArguments};
const genericBottomConstructor = {"genericBottom'": Data$dGeneric$dRep.NoArguments};
const genericBottomSum = {"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)};
const genericEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments);
const genericEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(genericEnumConstructor)(genericTopConstructor);
const genericEnumSum1 = /* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(genericEnumConstructor)(genericBottomConstructor))(genericBottomSum))(genericBottomSum);
const genericBoundedEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments);
const genericBoundedEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumSum(genericBoundedEnumConstructor);
const genericBoundedEnumSum1 = /* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(genericBoundedEnumConstructor)));
const Delivery = /* #__PURE__ */ $FulfillmentMethodType("Delivery");
const Takeaway = /* #__PURE__ */ $FulfillmentMethodType("Takeaway");
const DineIn = /* #__PURE__ */ $FulfillmentMethodType("DineIn");
const NoContactDelivery = /* #__PURE__ */ $FulfillmentMethodType("NoContactDelivery");
const getTranslationFulfillment = dictHasField => dictHasField1 => dictHasField2 => () => () => dictHasField3 => dictHasField4 => () => () => dictHasField5 => dictHasField6 => () => () => dictHasField7 => dictHasField8 => () => () => (
  {
    getTranslation: v => (
      {
        Delivery: {
          label: Restaumatic$dI18n._translate(
            Restaumatic$dI18n$dTranslationKeys.unTranslationKey(dictHasField2.getField(Type$dProxy.Proxy)(dictHasField1.getField(Type$dProxy.Proxy)(dictHasField.getField(Type$dProxy.Proxy)(Restaumatic$dCoreSites$dTranslations$dKeys.t)))),
            {}
          )
        },
        Takeaway: {
          label: Restaumatic$dI18n._translate(
            Restaumatic$dI18n$dTranslationKeys.unTranslationKey(dictHasField4.getField(Type$dProxy.Proxy)(dictHasField3.getField(Type$dProxy.Proxy)(dictHasField.getField(Type$dProxy.Proxy)(Restaumatic$dCoreSites$dTranslations$dKeys.t)))),
            {}
          )
        },
        DineIn: {
          label: Restaumatic$dI18n._translate(
            Restaumatic$dI18n$dTranslationKeys.unTranslationKey(dictHasField6.getField(Type$dProxy.Proxy)(dictHasField5.getField(Type$dProxy.Proxy)(dictHasField.getField(Type$dProxy.Proxy)(Restaumatic$dCoreSites$dTranslations$dKeys.t)))),
            {}
          )
        },
        NoContactDelivery: {
          label: Restaumatic$dI18n._translate(
            Restaumatic$dI18n$dTranslationKeys.unTranslationKey(dictHasField8.getField(Type$dProxy.Proxy)(dictHasField7.getField(Type$dProxy.Proxy)(dictHasField.getField(Type$dProxy.Proxy)(Restaumatic$dCoreSites$dTranslations$dKeys.t)))),
            {}
          )
        }
      }
    )
  }
);
const eqFulfillmentMethodType = {
  eq: x => y => {
    if (x.tag === "Delivery") { return y.tag === "Delivery"; }
    if (x.tag === "Takeaway") { return y.tag === "Takeaway"; }
    if (x.tag === "DineIn") { return y.tag === "DineIn"; }
    if (x.tag === "NoContactDelivery") { return y.tag === "NoContactDelivery"; }
    return false;
  }
};
const ordFulfillmentMethodType = {
  compare: x => y => {
    if (x.tag === "Delivery") {
      if (y.tag === "Delivery") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Delivery") { return Data$dOrdering.GT; }
    if (x.tag === "Takeaway") {
      if (y.tag === "Takeaway") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Takeaway") { return Data$dOrdering.GT; }
    if (x.tag === "DineIn") {
      if (y.tag === "DineIn") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "DineIn") { return Data$dOrdering.GT; }
    if (x.tag === "NoContactDelivery") {
      if (y.tag === "NoContactDelivery") { return Data$dOrdering.EQ; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqFulfillmentMethodType
};
const genericFulfillmentMethodType = {
  to: x => {
    if (x.tag === "Inl") { return Delivery; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return Takeaway; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return DineIn; }
        if (x._1._1.tag === "Inr") { return NoContactDelivery; }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Delivery") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "Takeaway") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "DineIn") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x.tag === "NoContactDelivery") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))); }
    $runtime.fail();
  }
};
const showFulfillmentMethodType = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(DeliveryIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(TakeawayIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(DineInIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(NoContactDeliveryIsSymbol);
    return x => {
      const $4 = genericFulfillmentMethodType.from(x);
      if ($4.tag === "Inl") { return $0["genericShow'"]($4._1); }
      if ($4.tag === "Inr") {
        if ($4._1.tag === "Inl") { return $1["genericShow'"]($4._1._1); }
        if ($4._1.tag === "Inr") {
          if ($4._1._1.tag === "Inl") { return $2["genericShow'"]($4._1._1._1); }
          if ($4._1._1.tag === "Inr") { return $3["genericShow'"]($4._1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeFulfillmentMethodType = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericFulfillmentMethodType)(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsConstruct(DeliveryIsSymbol))(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsConstruct(TakeawayIsSymbol))(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsConstruct(DineInIsSymbol))(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsConstruct(NoContactDeliveryIsSymbol)))))(Unscramble$dEnum.defaultEnumOptions)
};
const boundedFulfillmentMethodT = /* #__PURE__ */ (() => (
  {
    top: genericFulfillmentMethodType.to(Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments)))),
    bottom: genericFulfillmentMethodType.to(Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)),
    Ord0: () => ordFulfillmentMethodType
  }
))();
const enumFulfillmentMethodType = {
  succ: /* #__PURE__ */ Data$dEnum$dGeneric.genericSucc(genericFulfillmentMethodType)(genericEnumSum1),
  pred: /* #__PURE__ */ Data$dEnum$dGeneric.genericPred(genericFulfillmentMethodType)(genericEnumSum1),
  Ord0: () => ordFulfillmentMethodType
};
const boundedEnumFulfillmentMet = /* #__PURE__ */ (() => (
  {
    cardinality: genericBoundedEnumSum1["genericCardinality'"],
    toEnum: Data$dEnum$dGeneric.genericToEnum(genericFulfillmentMethodType)(genericBoundedEnumSum1),
    fromEnum: x => genericBoundedEnumSum1["genericFromEnum'"](genericFulfillmentMethodType.from(x)),
    Bounded0: () => boundedFulfillmentMethodT,
    Enum1: () => enumFulfillmentMethodType
  }
))();
const getOptionsFulfillmentMeth = dictEnum => dictBoundedEnum => dictGeneric => {
  const getEnumOptions = Restaumatic$dForm$dMetadata.getEnumOptions(dictGeneric)(dictBoundedEnum)(enumFulfillmentMethodType);
  return dictGEnumOptions => ({getOptions: getEnumOptions(dictGEnumOptions)});
};
const toFillFormTypeFulfillment = {
  fillFormDataType: /* #__PURE__ */ Restaumatic$dForm$dTestHelpers.defaultEnumFillFormDataType(genericFulfillmentMethodType)(/* #__PURE__ */ Restaumatic$dForm$dTestHelpers.gEnumToFillFormTypeSum({
    gdefaultEnumFillFormDataType: v => "\"Delivery\""
  })(/* #__PURE__ */ Restaumatic$dForm$dTestHelpers.gEnumToFillFormTypeSum({gdefaultEnumFillFormDataType: v => "\"Takeaway\""})(/* #__PURE__ */ Restaumatic$dForm$dTestHelpers.gEnumToFillFormTypeSum({
    gdefaultEnumFillFormDataType: v => "\"DineIn\""
  })({gdefaultEnumFillFormDataType: v => "\"NoContactDelivery\""}))))
};
const encodeFulfillmentMethodType = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumEncode(genericFulfillmentMethodType)({
    encodeEnum: v => v1 => {
      if (v1.tag === "Inl") { return v.constructorTagTransform("Delivery"); }
      if (v1.tag === "Inr") {
        if (v1._1.tag === "Inl") { return v.constructorTagTransform("Takeaway"); }
        if (v1._1.tag === "Inr") {
          if (v1._1._1.tag === "Inl") { return v.constructorTagTransform("DineIn"); }
          if (v1._1._1.tag === "Inr") { return v.constructorTagTransform("NoContactDelivery"); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
  })
};
const decodeFulfillmentMethodType = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumDecode(genericFulfillmentMethodType)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(DeliveryIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(TakeawayIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(DineInIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(NoContactDeliveryIsSymbol)))))
};
export {
  $FulfillmentMethodType,
  Delivery,
  DeliveryIsSymbol,
  DineIn,
  DineInIsSymbol,
  NoContactDelivery,
  NoContactDeliveryIsSymbol,
  Takeaway,
  TakeawayIsSymbol,
  boundedEnumFulfillmentMet,
  boundedFulfillmentMethodT,
  decodeFulfillmentMethodType,
  encodeFulfillmentMethodType,
  enumFulfillmentMethodType,
  eqFulfillmentMethodType,
  genericBottomConstructor,
  genericBottomSum,
  genericBoundedEnumConstructor,
  genericBoundedEnumSum,
  genericBoundedEnumSum1,
  genericEnumConstructor,
  genericEnumSum,
  genericEnumSum1,
  genericFulfillmentMethodType,
  genericTopConstructor,
  getOptionsFulfillmentMeth,
  getTranslationFulfillment,
  ordFulfillmentMethodType,
  showFulfillmentMethodType,
  toFillFormTypeFulfillment,
  unscrambleDecodeFulfillmentMethodType
};
